// extracted by mini-css-extract-plugin
export var chevron = "_kh-4";
export var chevronExpanded = "_kh-5";
export var row = "_kh-0";
export var rowBody = "_kh-6";
export var rowDescription = "_kh-7";
export var rowHeader = "_kh-1";
export var rowTitle = "_kh-2";
export var rowTitleComplete = "_kh-3";